import {
	IPendingMedia,
	TImageOrientation,
	TTypeOfErrorModalWindow,
	TTypeOfModalWindow,
} from './formImageUploaderNewContext';

export enum FormImageUploaderNewActionTypes {
	SET_IMAGE_ORIENTATION = 'SET_IMAGE_ORIENTATION',
	SET_LOADING = 'SET_LOADING',
	SET_UPLOADING_VIDEO = 'SET_UPLOADING_VIDEO',
	SET_CROPPED_SIZE_SRC = 'SET_CROPPED_SIZE_SRC',
	SET_COMMITTED_VIDEO_SRC = 'SET_COMMITTED_VIDEO_SRC',
	SET_PENDING_IMAGE = 'SET_PENDING_IMAGE',
	SET_PENDING_GIF = 'SET_PENDING_GIF',
	SET_PENDING_VIDEO = 'SET_PENDING_VIDEO',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_TYPE_OF_ERROR_MODAL_WINDOW = 'CHANGE_TYPE_OF_ERROR_MODAL_WINDOW',
	SET_LOADING_IMAGE_ERROR = 'SET_LOADING_IMAGE_ERROR',
}

interface ISetImageOrientation {
	type: FormImageUploaderNewActionTypes.SET_IMAGE_ORIENTATION;
	payload: {
		imageOrientation: TImageOrientation;
	};
}

interface ISetLoading {
	type: FormImageUploaderNewActionTypes.SET_LOADING;
	payload: {
		isLoading: boolean;
	};
}

interface ISetUploadingVideo {
	type: FormImageUploaderNewActionTypes.SET_UPLOADING_VIDEO;
	payload: {
		isUploadingVideo: boolean;
	};
}

interface ISetCroppedSizeSrc {
	type: FormImageUploaderNewActionTypes.SET_CROPPED_SIZE_SRC;
	payload: {
		src: string | null;
	};
}

interface ISetCommittedVideoSrc {
	type: FormImageUploaderNewActionTypes.SET_COMMITTED_VIDEO_SRC;
	payload: {
		src: string | null;
	};
}

interface ISetPendingImage {
	type: FormImageUploaderNewActionTypes.SET_PENDING_IMAGE;
	payload: {
		pendingImage: IPendingMedia;
	};
}

interface ISetPendingGif {
	type: FormImageUploaderNewActionTypes.SET_PENDING_GIF;
	payload: {
		pendingGif: IPendingMedia;
	};
}

interface ISetPendingVideo {
	type: FormImageUploaderNewActionTypes.SET_PENDING_VIDEO;
	payload: {
		pendingVideo: IPendingMedia;
	};
}

interface IChangeTypeOfModalWindow {
	type: FormImageUploaderNewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeTypeOfErrorModalWindow {
	type: FormImageUploaderNewActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW;
	payload: {
		typeOfErrorModalWindow: TTypeOfErrorModalWindow;
	};
}

interface ISetLoadingImageError {
	type: FormImageUploaderNewActionTypes.SET_LOADING_IMAGE_ERROR;
	payload: {
		loadingImageError: boolean;
	};
}

export type TFormImageUploaderNewAction =
	| ISetImageOrientation
	| ISetLoading
	| ISetUploadingVideo
	| ISetCroppedSizeSrc
	| ISetCommittedVideoSrc
	| ISetPendingImage
	| ISetPendingGif
	| ISetPendingVideo
	| IChangeTypeOfModalWindow
	| IChangeTypeOfErrorModalWindow
	| ISetLoadingImageError;
